class DetailsDisclosure extends HTMLElement {
  constructor() {
    super()
    this.mainDetailsToggle = this.querySelector('details')
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
  }

  onFocusOut() {
    document.addEventListener('click', function (event) {
      let clickedElement = event.target

      // Check if clickedElement is the excludedElement or its descendant
      if (!this.contains(clickedElement)) {
        setTimeout(() => {
          this.close()
        })
      }
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations()

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play())
    } else {
      this.animations.forEach((animation) => animation.cancel())
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super()
    this.header = document.querySelector('.header-wrapper')
    this.mainHeader = document.querySelector('.section-header')
  }

  onToggle() {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainHeader.classList.add('disclosure')
      document.body.classList.add('overflow-hidden')
    } else {
      this.mainHeader.classList.remove('disclosure')
      document.body.classList.remove('overflow-hidden')
    }
  }
}

customElements.define('header-menu', HeaderMenu)
